import { MetafieldKeys } from '@config/keys/metafield.keys';
import { ComoAttachUserResponse } from '@core/models/como.model';
import { DoodUserModel } from '@store/authentication/authentication.model';

export type ComoRegistrationNextStep = 'complete' | 'authentication';

export type ComoPostAttachRouteDecision = {
  nextStep: ComoRegistrationNextStep;
  reason: string;
};

export function hasComoAccountOnMarketplace(
  user: DoodUserModel | null | undefined,
  marketplaceId: string,
): boolean {
  const metafields = user?.metafields;
  if (!metafields || !Array.isArray(metafields)) {
    return false;
  }
  return metafields.some(metafield =>
    new RegExp(`^como_user_id_marketplace_${marketplaceId}$`).test(metafield[MetafieldKeys.Handle]),
  );
}

/**
 * After attach-user (phone or OTP), decide whether the registration modal should
 * close and redirect (like create-or-link / kiosk) or show the password step.
 */
export function resolveComoRegistrationStepAfterAttach(
  response: ComoAttachUserResponse,
  user: DoodUserModel | null | undefined,
  marketplaceId: string,
  allowAnonymousUser: boolean,
): ComoPostAttachRouteDecision {
  if (response.custom_token) {
    return { nextStep: 'complete', reason: 'custom_token' };
  }
  if (user?.is_anonymous === false) {
    return { nextStep: 'complete', reason: 'user_not_anonymous' };
  }
  if (allowAnonymousUser) {
    return { nextStep: 'complete', reason: 'allow_anonymous_user' };
  }
  if (marketplaceId && hasComoAccountOnMarketplace(user, marketplaceId)) {
    return { nextStep: 'complete', reason: 'como_metafield_attached' };
  }
  return { nextStep: 'authentication', reason: 'requires_account_upgrade' };
}
